import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
const OPENAI_PIXEL_ID = "Lf982BotHuG6jNMrDRwFCT";
const OPENAI_PIXEL_SCRIPT_URL = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
export default function OpenAIPixel() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="openai-pixel" strategy="afterInteractive">{`
        if (!window.__guestGalleryOpenAIPixelInitialized) {
          window.__guestGalleryOpenAIPixelInitialized = true;
          !function(w,d,s,u){if(w.oaiq)return;var q=function(){q.q.push(arguments)};q.q=[];w.oaiq=q;var j=d.createElement(s);j.async=1;j.src=u;var f=d.getElementsByTagName(s)[0];f.parentNode.insertBefore(j,f)}(window,document,"script","${OPENAI_PIXEL_SCRIPT_URL}");
          oaiq("init",{pixelId:"${OPENAI_PIXEL_ID}",debug:false});
          window.dispatchEvent(new Event("guestgallery:openai-pixel-ready"));
        }
      `}</Script>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}